export default __webpack_public_path__ + "static/media/art_img.42ba2a08.png";